import React from 'react';
import { ChevronDownIcon, FilterIcon } from 'lucide-react';
import { JobsTable } from '../../dashboard/JobsTable';
interface CompletedJobsProps {
  jobs: any[];
}
export const CompletedJobs = ({
  jobs
}: CompletedJobsProps) => {
  const columns = [{
    key: 'name',
    header: 'JOB NAME',
    sortable: true
  }, {
    key: 'jobNumber',
    header: 'JOB #',
    sortable: false
  }, {
    key: 'date',
    header: 'DATE',
    sortable: true
  }, {
    key: 'broker',
    header: 'BROKER',
    sortable: false
  }, {
    key: 'truckingCompany',
    header: 'TRUCKING COMPANY',
    sortable: false
  }, {
    key: 'driver',
    header: 'DRIVER',
    sortable: false
  }, {
    key: 'truckType',
    header: 'TRUCK TYPE',
    sortable: false
  }, {
    key: 'material',
    header: 'MATERIAL',
    sortable: false
  }, {
    key: 'totalTons',
    header: 'TOTAL TONS',
    sortable: true
  }, {
    key: 'rate',
    header: 'RATE',
    sortable: true
  }, {
    key: 'amount',
    header: 'AMOUNT',
    sortable: true
  }];
  return <div className="bg-white rounded-md shadow overflow-hidden mt-6" data-id="element-1340">
      <div className="flex items-center justify-between p-4 bg-gray-50" data-id="element-1341">
        <div className="flex items-center gap-2" data-id="element-1342">
          <span className="h-5 w-5 rounded-full bg-green-500 flex items-center justify-center text-white" data-id="element-1343">
            <span data-id="element-1344">✓</span>
          </span>
          <h3 className="font-medium" data-id="element-1345">Completed Jobs</h3>
          <span className="text-gray-500 text-sm" data-id="element-1346">(11 of 11 jobs)</span>
        </div>
        <div className="flex items-center gap-3" data-id="element-1347">
          <button className="flex items-center gap-1 text-sm text-gray-600" data-id="element-1348">
            <FilterIcon size={16} data-id="element-1349" />
            Show Filters
          </button>
          
          <button className="text-gray-500" data-id="element-1350">
            <ChevronDownIcon size={20} data-id="element-1351" />
          </button>
        </div>
      </div>
      <div className="p-4 overflow-x-auto" data-id="element-1352">
        <JobsTable columns={columns} data={jobs} data-id="element-1353" />
      </div>
    </div>;
};